<template>
    <div class="row py-3 bt-dash">
        <div class="col-sm-9 d-flex justify-content-center">
            <div style="aspect-ratio: 1 / 1; width: 25%;">
                <img v-if="compState.imageUrl" :src="compState.imageUrl" alt="Image Preview"
                    class="img-thumbnail w-100 h-100 object-fit-cover">
                <div v-else class="img-thumbnail w-100 h-100 d-flex align-items-center justify-content-center"
                    style="background-color: #f0f0f0;">
                    <span>No Image</span>
                </div>
            </div>
        </div>
        <div class="col-sm-3 d-flex align-items-center">
            <div class="mb-3 w-100">
                <label for="image-upload" class="form-label">Upload Image</label>
                <input class="form-control mb-3" type="file" id="image-upload" @change="previewImage" ref="fileInput">
                <button v-if="compState.imageUrl" class="btn btn-danger w-100" @click="removeImage">Remove
                    Image</button>
                <div v-else style="height: 35px;">

                </div>
            </div>
        </div>
    </div>
    <div class=" row py-3 bt-dash">
        <div class=" col-sm-9">
            <h6 class="f-w-700">Button Color</h6>
            <div class=" color-list-container mt-3" style="min-height: 320px;">
                <div class="text-center py-2 rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center"
                    style="height: 96px;" @click="onColorClick(item.id)" :style="{
                        backgroundColor: item.color, gridColumn: 'span 1 / span 1',
                        boxShadow: compState.activeColor === item.id ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none'
                    }" v-for="item in colorList" :key="item.id">
                    <h5 class="text-white">{{ item.name }}</h5>
                </div>
            </div>
        </div>
        <div class=" col-sm-3 d-flex flex-column ">
            <h6 class="f-w-700 mb-3">Button Font Size</h6>
            <div class=" d-flex flex-column justify-content-between w-100 flex-grow-1">
                <button type="button" class="btn btn-outline-primary w-100 py-3"
                    :class="{ ' btn-primary': compState.buttonSize === 'X-Large' }" @click="setFontSize('X-Large')"
                    style="font-size: 1.5rem;">X-Large</button>
                <button type="button" class="btn btn-outline-primary w-100 py-3"
                    :class="{ ' btn-primary': compState.buttonSize === 'Large' }" @click="setFontSize('Large')"
                    style="font-size: 1.25rem;">Large</button>
                <button type="button" class="btn btn-outline-primary w-100 py-3"
                    :class="{ ' btn-primary': compState.buttonSize === 'Medium' }" @click="setFontSize('Medium')"
                    style="font-size: 1rem;">Medium</button>
                <button type="button" class="btn btn-outline-primary w-100 py-3"
                    :class="{ ' btn-primary': compState.buttonSize === 'Small' }" @click="setFontSize('Small')"
                    style="font-size: 0.875rem;">Small</button>
            </div>
        </div>
    </div>

</template>

<script setup lang="ts">
import { ref, reactive, onMounted, computed, watch } from 'vue';
import { useProductsStore } from '@/store/management/productsStore';

const productStore = useProductsStore();

const compState = reactive({
    imageUrl: '',
    buttonSize: '',
    activeColor: '',
});

const fileInput = ref<HTMLInputElement | null>(null);


const colorList = ref([
    { id: '1', name: 'Red', color: '#FF0000' },
    { id: '2', name: 'Green', color: '#00aa00' },
    { id: '3', name: 'Blue', color: '#0000FF' },
    { id: '4', name: 'Yellow', color: '#FFFF00' },
    { id: '5', name: 'Cyan', color: '#00FFFF' },
    { id: '6', name: 'Magenta', color: '#FF00FF' },
    { id: '7', name: 'Orange', color: '#FFA500' },
    { id: '8', name: 'Purple', color: '#800080' },
    { id: '9', name: 'Brown', color: '#A52A2A' },
    { id: '10', name: 'Pink', color: '#FFC0CB' },
    { id: '11', name: 'Lime', color: '#32cd32' },
    { id: '12', name: 'Teal', color: '#008080' },
]);

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        compState.imageUrl = tempActiveProduct.value?.appearance?.image || '';
        compState.buttonSize = tempActiveProduct.value?.appearance?.fontSizes || '';
        compState.activeColor = tempActiveProduct.value?.appearance?.buttonColor || '';
    }
    console.log('tempActiveDepartment', tempActiveProduct.value);

});

watch(activeProductId, (newVal) => {
    if (newVal) {
        const department = activeProduct.value
        compState.imageUrl = department.appearance.image;
        compState.buttonSize = department.appearance.fontSizes;
        compState.activeColor = department.appearance.buttonColor;
        if (fileInput.value) {
            fileInput.value.value = '';
        }
    }
});

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        appearance: {
            ...tempActiveProduct.value?.appearance,
            image: compState.imageUrl,
            fontSizes: compState.buttonSize,
            buttonColor: compState.activeColor,
        }
    });
}, { deep: true });

function previewImage(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
        compState.imageUrl = URL.createObjectURL(file);
    }
}

function removeImage() {
    compState.imageUrl = '';
    if (fileInput.value) {
        fileInput.value.value = '';
    }
}
function setFontSize(size: string) {
    compState.buttonSize = size;
}
function onColorClick(id: string) {
    compState.activeColor = id;
}
</script>

<style scoped lang="scss">
.btn.btn-primary {
    color: white !important;
}

.color-list-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}
</style>